export const FREQUENCY = {
  ONE_TIME: 'one-time',
  DAILY: 'daily',
  WEEKLY: 'weekly',
  BI_WEEKLY: 'bi-weekly',
  MONTHLY: 'monthly',
  QUARTERLY: 'quarterly',
  SEMI_ANNUALLY: 'semi-annually',
  YEARLY: 'yearly'
};